export default function ProductNotFound() {
  return (
    <section className="base-container">
      <section className="mt-3 text-center">
        <article className="col-auto">
          <label className="text-center">Shop Name</label>
        </article>

        <label className="form-label" style={{ font: "bold 20px roboto" }}>
          Product not found.
        </label>
      </section>

      <section className="text-center">
        <article
          className="mt-2.5 mb-3 text-muted"
          style={{ fontSize: "13px !important" }}
        >
          <small>
            Powered by <strong>tidus</strong>
          </small>
        </article>
      </section>
    </section>
  );
}
